import script from "./AppHeader.vue?vue&type=script&lang=js&setup=true"
export * from "./AppHeader.vue?vue&type=script&lang=js&setup=true"

import "./AppHeader.vue?vue&type=style&index=0&id=44481ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44481ddc"]])

export default __exports__